import { showToast } from "../../components/toast.component";
import { AppRouteApi } from "../../config/appRoute";
import {
  ApiResponseContainer,
  IApiSchemaSyncActivation,
  IApiSchemaSyncAppointment,
} from "../../models/api";
import { AxiosAuth } from "../axios";
import { IApiActions } from "./common";

interface IParamsSyncAppointment extends IApiActions<any> {
  data: IApiSchemaSyncAppointment;
}

async function SyncAppointment({
  data,
  onStart,
  onSuccess,
  onFail,
  onEnd,
}: IParamsSyncAppointment) {
  try {
    onStart?.();
    await AxiosAuth.post<ApiResponseContainer<unknown>>(
      AppRouteApi.HouseKeeping.VisitByDateRange(),
      data
    );
    onSuccess?.(null);
  } catch (error: any) {
    showToast(error.message, "error", "bottomEnd", 8000);
    onFail?.();
  } finally {
    onEnd?.();
  }
}

async function SyncAppointmentCheckData({
  data,
  onStart,
  onSuccess,
  onFail,
  onEnd,
}: IParamsSyncAppointment) {
  try {
    onStart?.();
    await AxiosAuth.post<ApiResponseContainer<unknown>>(
      AppRouteApi.HouseKeeping.VisitByDateRange(),
      data
    );
    showToast('Data sync completed successfully', 'success', 'bottomEnd', 4000);
    onSuccess?.(null);
  } catch (error: any) {
    showToast(error.message, "error", "bottomEnd", 4000);
    onFail?.();
  } finally {
    onEnd?.();
  }
}

async function GetNewToken({
  onStart,
  onEnd,
  onSuccess,
  onFail,
  companyId,
}: IApiActions<IApiSchemaSyncActivation> & { companyId: string }) {
  try {
    if (!companyId) {
      showToast("Select a company first", "error", "bottomEnd", 5000, true);
      onFail?.();
      return;
    }

    onStart?.();
    const response = await AxiosAuth.post<IApiSchemaSyncActivation>(
      AppRouteApi.HouseKeeping.GenerateToken(),
      {
        companyId,
      }
    );
    onSuccess?.(response.data);
  } catch (error: any) {
    showToast("Failed to generate token", "error", "bottomEnd", 8000, false);
    onFail?.();
  } finally {
    onEnd?.();
  }
}

async function GetExistingToken({
  onStart,
  onEnd,
  onSuccess,
  onFail,
  companyId,
}: IApiActions<IApiSchemaSyncActivation> & { companyId: string }) {
  try {
    if (!companyId) {
      showToast("Select a company first", "error", "bottomEnd", 5000, true);
      onFail?.();
      return;
    }

    onStart?.();
    const response = await AxiosAuth.get<IApiSchemaSyncActivation>(
      `${AppRouteApi.HouseKeeping.GetToken()}?companyId=${companyId}`
    );
    onSuccess?.(response.data);
  } catch (error: any) {
    onFail?.();
  } finally {
    onEnd?.();
  }
}

export const ApiDataExchange = {
  SyncAppointment,
  GetNewToken,
  GetExistingToken,
  SyncAppointmentCheckData,
};
